/**
 * File archive-financial-glossary.js.
 * Handles open/close archive search on mobile.
 * Handles sticky archive nav on desktop.
 * Handles highlighting letter item while scrolled to section.
 * handles overriding the anchor clicks with scrollIntoView
 */

if (typeof jQuery !== "undefined")
  jQuery(function ($) {

    let archive = document.querySelector(".post-type-archive-financial_glossary");
    let searchPage = document.querySelector(".search-results");

    // if there is no Nav
    if (!archive || searchPage) return;
    
    // shared props
    const MOBILE_BREAK = 860;

    // sticky props
    let topBanner;
    let header;
    let archiveNav;
    let termSet;
    let stickyState = false; // unstuck is the default state
    let upperBound;
    let topBannerHeight;
    let headerHeight;
    let totalHeaderBlockHeight;
    let windowHeight;
    let wpBarHeight;
    let searchInput;
    
    // hightlighting props
    let highlightedItem = null;
    let indexSections = null;
    const activeClassName = "financial-glossary__navigation-btn--active";
    
    // open/close Nav on mobile
    let openSearchBtn;
    let closeSearchBtn;
    let backSearchBtn;
    let wpBar;
    let navBar;
    let heroWrapper;
    
    const initializeDomValues = () => {
      windowHeight = window.innerHeight;
      
      // Sticky sidebar page elements
      topBanner = document.querySelector(".top-banner");
      header = document.querySelector("#header");
      termSet =  document.querySelector(".financial-glossary__term-set");
      archiveNav = document.querySelector(".financial-glossary__navigation");
      searchInput = document.querySelector('.financial-glossary__searchform-input');

      wpBar = document.querySelector("#wpadminbar");
      navBar = document.querySelector(".financial-glossary__navigation-bar");
      openSearchBtn = document.querySelector(".financial-glossary__search-open-btn");
      closeSearchBtn = document.querySelector(".financial-glossary__close-btn");
      backSearchBtn = document.querySelector(".financial-glossary__back-btn");
      heroWrapper = document.querySelector(".financial-glossary__hero-wrapper");
      // the Nav sections for highlighting and scrollIntoView
      indexSections = Array.from(
        archive.querySelectorAll("a.financial-glossary__navigation-btn")
      ).map((item) => {
        const id = item.getAttribute("href").replace("#", "");
        const section = document.getElementById(`${id}-section`);
        const anchor = document.getElementById(id);
        return { item, anchor, section };
      });
    };

    /**
     * MARK: - Open/Close Archive Nav
     */

    const openMobileSearch = () => {
      archive.classList.remove("search-closed");
      archive.classList.add("search-open");
      wpBar.style.display = "none";
    }

    const closeMobileSearch = () => {
      archive.classList.remove("search-open");
      archive.classList.add("search-closed");
      wpBar.style.display = "block";

      // this is to catch an edge case where the user
      // 1 opens the search on mobile
      // 2 scrolls down bellow the sticky point
      // 3 closes the search
      stickyState = false;
      updateSticky();
    }

    const clearSearchInput = () => {
      searchInput.value = '';
    };

    const initializeOpenClose = () => {
      if (!archive) return;

      openSearchBtn.addEventListener("click", openMobileSearch);
      closeSearchBtn.addEventListener("click", clearSearchInput);
      backSearchBtn.addEventListener("click", closeMobileSearch);
    };

    /**
     * MARK: - Highlight Nav Item
     */

    const applyHighLightTo = (item) => {
      if (highlightedItem)
        highlightedItem.classList.remove(activeClassName);
      highlightedItem = item;
      highlightedItem.classList.add(activeClassName);
    };

    const updateHighlighted = () => {
      if(!Array.isArray(indexSections)) return;

      const current = indexSections.find(({ section }) => {
        if (!indexSections) return;

        const { top, bottom } = section.getBoundingClientRect();
        const isMobile = window.innerWidth < MOBILE_BREAK;
        const isFirst = section == indexSections[0]['section'];
        const isMatch = () => {
          if(isMobile) {
            return isFirst ? bottom > 160 : top <= 250 && bottom > 160;
          } else {
            return isFirst ? bottom > 210 : top <= 230 && bottom > 210;
          }
        };
        return isMatch();
      });

      if (current && current.item !== highlightedItem) {
        applyHighLightTo(current.item);
      } else if (!current && highlightedItem) {
        highlightedItem.classList.remove(activeClassName);
      }
    };

    const initializeHighlighting = () => {
      updateHighlighted();

      window.addEventListener("scroll", () => {
        updateHighlighted();
      });
    };

    /**
     * MARK: - Sticky Nav
     */

    const clearAllSticky = () => {
      if (archiveNav && header) {
        archiveNav.classList.remove("financial-glossary__navigation--unstuck");
        archiveNav.classList.remove("financial-glossary__navigation--stuck");
        header.classList.remove("header--is-scrolled--no-shadow");
        archiveNav.style.top = "unset";
      }
    };

    const applyStickyOff = () => {      
      if (stickyState && archiveNav && header) {
        clearAllSticky();
        archiveNav.classList.add("financial-glossary__navigation--unstuck");
        archiveNav.style.top = "unset";
        stickyState = false;
      }
    };

    const applyStickyOn = () => {      
      if (!stickyState && archiveNav && header) {
        clearAllSticky();
        archiveNav.classList.add("financial-glossary__navigation--stuck");
        archiveNav.style.top = `${totalHeaderBlockHeight}px`;
        header.classList.add("header--is-scrolled--no-shadow");
        stickyState = true;
      }
    };

    const setBounds = () => {
      const isMobile = window.innerWidth < MOBILE_BREAK;
      const offset = isMobile ? 18 : 64;
      topBannerHeight = topBanner ? topBanner.offsetHeight : 0;
      headerHeight = header ? header.offsetHeight : 0;
      wpBarHeight = wpBar && $(wpBar).css('position') == 'fixed' ? wpBar.offsetHeight : 0;
      totalHeaderBlockHeight = topBannerHeight + headerHeight + wpBarHeight;
      upperBound = termSet ? $(".financial-glossary__term-set").first().position().top - totalHeaderBlockHeight + offset : 0;
    };

    const updateSticky = () => {
      setBounds();
      const scroll = window.scrollY;

      if (scroll < upperBound) {
        applyStickyOff();
      } else if (scroll >= upperBound ) {
        applyStickyOn();
      }
    }

    // seems to be a race condition, jQ can't always get the height of the nav right on load
    setTimeout(updateSticky, 10);
    window.addEventListener("scroll", updateSticky);

    /**
     * MARK: - scrollIntoView
     */   
    const scrollTo = (item) => item.scrollIntoView({ behavior: "smooth", block: "start" });

    const initialScrollTo = () => {
      if(!Array.isArray(indexSections)) return;

      indexSections.map(({ item, section, anchor }) => {
        item.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          scrollTo(anchor);
        });
      });
    };

    /**
     * MARK: - Initialize
     */

    initializeDomValues();
    initializeHighlighting();
    initialScrollTo();
    initializeOpenClose();
  });
